import React from 'react'
import AccordionWrapper from 'redesign/components/molecules/AccordionWrapper'
import { ShiftSectionsContainer } from 'redesign/components/organisms/ShiftPlanSections/ShiftSection/styles'
import { BadgeSkeleton, BodyContainer, BodyLabel, HeaderContainer, TitleLabel } from './styles'
import type { ShiftCardSkeletonProps } from './types'
import { getRandomLabelWidth } from './utils'

const ShiftCardSkeleton: React.FC<ShiftCardSkeletonProps> = ({ bodyLines = 1 }) => (
  <AccordionWrapper
    header={
      <HeaderContainer>
        <BadgeSkeleton />
        <TitleLabel animation="wave" />
      </HeaderContainer>
    }
  >
    <ShiftSectionsContainer>
      {React.useMemo(
        () =>
          Array.from({ length: bodyLines }).map((_, index) => {
            const randomWidthLeft = getRandomLabelWidth()
            const randomWidthRight = getRandomLabelWidth()

            return (
              // Disabled to avoid warning for using index as key
              // eslint-disable-next-line react/no-array-index-key
              <BodyContainer key={index}>
                <BodyLabel animation="wave" width={randomWidthLeft} />
                <BodyLabel animation="wave" width={randomWidthRight} />
              </BodyContainer>
            )
          }),
        [bodyLines],
      )}
    </ShiftSectionsContainer>
  </AccordionWrapper>
)

export default ShiftCardSkeleton
